import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApexYAxis } from 'ng-apexcharts';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ApxChartConfig {
  decimalsInFloat: number
}

@Pipe({
  name: 'appDashboardChartYAxis'
})
export class DashboardChartYAxisPipe implements PipeTransform {
  private readonly baseConfig: ApxChartConfig = {
    decimalsInFloat: 2
  };

  private readonly baseLabel = {
    formatter: (value: number) => {
      return value.toFixed(2) + '%';
    }
  }

  private readonly integerLabel = {
    formatter: (value: number) => {
      return value.toFixed(0)
    }
  }

  constructor(
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  public transform(bigChartStats: any[]): Observable<ApexYAxis[]> {
    const names = bigChartStats
      .map(item => item?.name)
      .filter(Boolean)
      .slice(0, 2);

    if (!names.length) {
      return of([]);
    }

    return this.translateService.get(names).pipe(
      map((translations: Record<string, string>) =>
        Object.values(translations).map((translatedName, idx) => {
          const customLabel = bigChartStats[idx].isPercentage ? this.baseLabel : this.integerLabel;
          this.cdr.detectChanges();
          return {
            ...this.baseConfig,
            title: {
              text: bigChartStats[idx].isPercentage ? translatedName + ' %' : translatedName
            },
            opposite: idx === 1,
            labels: customLabel
          };
        })
      )
    );
  }
}
